/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { EducationDegree } from '../enums/education-degree';
import { AreaOfStudyEntity } from './area-of-study-entity';
import { LawSchoolEntity } from './law-school-entity';
export class EducationEntity extends Entity {
  areaOfStudy: AreaOfStudyEntity | null = null;
  areaOfStudyId: string | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  degree: EducationDegree | null = null;
  id: string = '';
  institutionStored: string | null = null;
  get institution(): string | null {
    return this.lawSchool?.name ?? this.institutionStored;
  }
  set institution(value: string | null) {
    this.institutionStored = value;
  }
  isPrimary: boolean | null = null;
  lastUpdatedBy: string | null = null;
  lawSchool: LawSchoolEntity | null = null;
  lawSchoolId: string | null = null;
  updatedAt: string | null = null;
  yearAwarded: number | null = null;
  static override key = 'Education';
  static override get schema() {
    return {
      areaOfStudy: AreaOfStudyEntity,
      lawSchool: LawSchoolEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (input === null || typeof input !== 'object') {
      return input;
    }
    const next: Record<string, unknown> = {
      ...(input as Record<string, unknown>),
    };
    if ('Education' in next) {
      const wrapped = next.Education as Record<string, unknown>;
      delete next.Education;
      Object.keys(wrapped).forEach(key => {
        if (!(key in next)) {
          next[key] = wrapped[key];
        }
      });
    }
    if (next.lawSchool === undefined && next.lawSchoolId != null) {
      next.lawSchool = { id: next.lawSchoolId };
    }
    if ('institution' in next) {
      next.institutionStored = next.institution;
      delete next.institution;
    }
    return next;
  }
}